// Shared utilities for admin functions
import {
  getUserPoints,
  updateUserPoints,
} from "lib/purchaseUtils"
import { USER_MAPPING } from "../../../../utils/userMapping"
import { getUserLevelInfo } from "../../../../utils/xpUtils"

/**
 * Load user points with level information
 */
export const loadAllUserPoints = async () => {
  const pointsData = {}
  const validUsers = Object.entries(USER_MAPPING).filter(
    ([_, uid]) => !uid.startsWith("REPLACE_WITH_")
  )

  for (const [userName, uid] of validUsers) {
    try {
      const points = await getUserPoints(uid)
      const levelInfo = getUserLevelInfo(points)

      pointsData[userName] = {
        uid,
        points,
        level: levelInfo.level,
        xpProgress: levelInfo.xpProgress,
      }
    } catch (error) {
      pointsData[userName] = {
        uid,
        points: 0,
        level: 1,
        xpProgress: 0,
      }
    }
  }

  return pointsData
}

/**
 * Reset all user points to zero
 */
export const resetAllUserPoints = async () => {
  const validUsers = Object.entries(USER_MAPPING).filter(
    ([_, uid]) => !uid.startsWith("REPLACE_WITH_")
  )

  for (const [, uid] of validUsers) {
    await updateUserPoints(uid, 0)
  }
}

/**
 * Format date from Firebase timestamp
 */
export const formatDate = (timestamp) => {
  if (!timestamp) return "Unknown date"

  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp)
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

/**
 * Get appropriate icon component for store items
 */
export const getItemIcon = (itemName) => {
  // This is imported dynamically in components that need it
  // to avoid circular dependencies
  if (itemName.toLowerCase().includes("slushie")) return "LocalDrink"
  if (itemName.toLowerCase().includes("screen")) return "ScreenShare"
  return "Star"
}
